// Copyright 2026 Intuition Robotics ltd
//
// Placeholder shown in place of an embedded external web app (iframe view) when
// running in offline mode. Those views load a separate deployed site (package
// manager, messaging, etc.) that can't be reached — and is blocked by CSP —
// offline, so render a clear notice instead of a blank/broken frame.

import * as React from "react";

export const OfflineIframeNotice = ({title}: { title?: string }) =>
    <div
        className={"match_width match_height"}
        style={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
            gap: 12,
            color: "#636363",
            textAlign: "center",
            padding: 24
        }}
    >
        <div style={{fontSize: 40}}>🔌</div>
        <div style={{fontSize: 18, fontWeight: 600}}>
            {title ? `${title} is unavailable offline` : "This view is unavailable offline"}
        </div>
        <div style={{maxWidth: 460, lineHeight: "1.5"}}>
            It embeds an external web app that can't be reached in offline mode.
            Run the app online (<code>-se=local</code> without <code>--offline</code>) to use it.
        </div>
    </div>;
